import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "verify-screen" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "input-wrapper" }
const _hoisted_5 = { class: "input-with-suggestions" }
const _hoisted_6 = { class: "input-shell" }
const _hoisted_7 = {
  key: 0,
  class: "success-toast"
}
const _hoisted_8 = { class: "codes-container" }
const _hoisted_9 = { class: "codes-header" }
const _hoisted_10 = { class: "codes-title" }
const _hoisted_11 = { class: "badge" }
const _hoisted_12 = {
  key: 0,
  class: "last-refresh"
}
const _hoisted_13 = { class: "codes-list" }
const _hoisted_14 = { class: "codes-list-inner" }
const _hoisted_15 = { class: "codes-list-transition" }
const _hoisted_16 = { class: "order-popover-content" }
const _hoisted_17 = { class: "popover-item" }
const _hoisted_18 = { class: "popover-value" }
const _hoisted_19 = { class: "popover-item" }
const _hoisted_20 = { class: "popover-value" }
const _hoisted_21 = {
  key: 0,
  class: "popover-item"
}
const _hoisted_22 = { class: "popover-value" }
const _hoisted_23 = {
  key: 1,
  class: "popover-item"
}
const _hoisted_24 = { class: "popover-value" }
const _hoisted_25 = {
  key: 2,
  class: "popover-item"
}
const _hoisted_26 = { class: "popover-value" }
const _hoisted_27 = {
  key: 3,
  class: "popover-item"
}
const _hoisted_28 = { class: "popover-value" }
const _hoisted_29 = {
  key: 4,
  class: "popover-food-list"
}
const _hoisted_30 = { class: "popover-food-list-scroll" }
const _hoisted_31 = { class: "food-name-row" }
const _hoisted_32 = { class: "food-name" }
const _hoisted_33 = { class: "food-quantity" }
const _hoisted_34 = {
  key: 0,
  class: "food-spec"
}
const _hoisted_35 = {
  key: 1,
  class: "food-cook"
}
const _hoisted_36 = {
  key: 2,
  class: "food-remark"
}
const _hoisted_37 = { class: "food-price-row" }
const _hoisted_38 = { class: "food-price" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "code-content" }
const _hoisted_41 = {
  key: 0,
  class: "fas fa-crown vip-icon"
}
const _hoisted_42 = { class: "code-text" }
const _hoisted_43 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_44 = {
  key: 0,
  class: "scan-modal-backdrop"
}
const _hoisted_45 = { class: "scan-modal" }
const _hoisted_46 = { class: "scan-modal-status" }
const _hoisted_47 = { class: "scan-feedback" }
const _hoisted_48 = { class: "scan-feedback-line" }
const _hoisted_49 = { class: "scan-feedback-line result" }
const _hoisted_50 = { class: "scan-panel" }
const _hoisted_51 = {
  key: 0,
  class: "scan-empty"
}

import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue';
  import { Html5Qrcode } from 'html5-qrcode';
  import { getOrderList, completeOrder } from '@/service/order';
  import { fetchShopList } from '@/service/base';
  import { readSelectedShop } from '@/utils/selectedShop';
  import type { ShopDetailModel } from '@/model/shop';
  import { OrderListItemModel } from '@/model/order';
  import { message } from 'ant-design-vue';
  import okSoundSrc from '@/assets/audio/ok.mp3';
  import errorSoundSrc from '@/assets/audio/error.mp3';

  interface PickCodeItem {
    pickCode: string;
    order?: OrderListItemModel;
  }

  // 输入框取餐码（兼做筛选关键字）
  const scannerContainerId = 'pickcode-qrcode-reader';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'PickCodeVerificationView',
  setup(__props) {

  const inputPickCode = ref('');
  const autoCompleteRef = ref<{ focus?: () => void } | null>(null);

  // 完整取餐码列表（后续可由接口填充，下方列表始终展示全部）
  const allPickCodeList = ref<PickCodeItem[]>([]);

  // AutoComplete 选项：根据当前输入内容进行筛选
  const autoCompleteOptions = computed(() => {
    const keyword = inputPickCode.value.trim();
    const source = allPickCodeList.value;
    if (!keyword) {
      return source.map((item) => ({ value: item.pickCode }));
    }
    return source
      .filter((item) => item.pickCode.toLowerCase().includes(keyword.toLowerCase()))
      .map((item) => ({ value: item.pickCode }));
  });

  // 最近刷新时间（预留，后续可在拉取接口时更新）
  const lastRefreshTime = ref('');

  // 模拟核销结果提示
  const successMessage = ref('');

  // 店铺选择相关
  const shopList = ref<ShopDetailModel[]>([]);
  // 当前生效的店铺ID（仅来自 URL 或下拉选择）
  const currentShopId = ref<number | null>(null);

  // 自动刷新定时器
  let autoRefreshTimer: NodeJS.Timeout | null = null;

  // 扫码核销相关
  const showScanModal = ref(false);
  const isScannerRunning = ref(false);
  const scanQueue = ref<string[]>([]);
  const isQueueProcessing = ref(false);
  const lastScannedText = ref('');
  const scanVerifyResult = ref('');
  let html5Qrcode: Html5Qrcode | null = null;
  const lastScanTimeMap = new Map<string, number>();
  let okAudio: HTMLAudioElement | null = null;
  let errorAudio: HTMLAudioElement | null = null;

  // 是否 VIP 取餐码（示例：以 V 开头）
  const isVipCode = (code: string | undefined) => {
    if (!code) return false;
    return code.toUpperCase().startsWith('V');
  };

  // 加载当前账号可见的餐厅，用于解析缓存餐厅名称。
  const loadShopList = async () => {
    try {
      const response = await fetchShopList({
        pageNum: 1,
        pageSize: 100,
        data: { shopStatus: 0 },
      });
      if (response.code === 200 && response.result && response.result.list) {
        shopList.value = response.result.list;
      }
    } catch (error) {
      console.error('加载店铺列表失败:', error);
    }
  };

  // 更新刷新时间
  const updateRefreshTime = () => {
    const now = new Date();
    lastRefreshTime.value = `${String(now.getHours()).padStart(2, '0')}:${String(
      now.getMinutes(),
    ).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
  };

  // 获取取餐码列表
  const fetchPickCodeList = async () => {
    const shopId = currentShopId.value;
    if (!shopId) {
      console.error('未获取到 shopId，无法加载取餐码列表');
      return;
    }

    try {
      const respOrder = await getOrderList({
        pageNum: 1,
        pageSize: 999,
        data: {
          shopId: shopId,
          orderStatuss: [8],
          sortType: 2,
        },
      });

      if (respOrder.code === 200 && respOrder.result?.list) {
        type OrderWithPickCode = Partial<OrderListItemModel> & { pickCode?: string };
        // 过滤出有 pickCode 的订单，并保存完整订单信息
        const pickCodeItems: PickCodeItem[] = respOrder.result.list
          .filter((order: OrderWithPickCode) => order.pickCode && order.pickCode.trim() !== '')
          .map((order: OrderWithPickCode) => ({
            pickCode: order.pickCode,
            order: order as OrderListItemModel,
          }));

        // 调试：打印当前所有待核销取餐码
        try {
          const codesForLog = pickCodeItems.map((x) => x.pickCode);
          // eslint-disable-next-line no-console
          console.log(
            '[PickCodeVerification] 当前待核销取餐码数量:',
            codesForLog.length,
            '列表:',
            codesForLog.join(', '),
          );
        } catch (e) {
          // ignore log errors
        }

        // 按下单时间倒序排序，最新的取餐码排在最前面，避免新数据刷到列表底部看不到
        pickCodeItems.sort((a, b) => {
          const ta = a.order?.createTime ? new Date(a.order.createTime).getTime() : 0;
          const tb = b.order?.createTime ? new Date(b.order.createTime).getTime() : 0;
          return tb - ta;
        });

        console.log('pickCodeItems', pickCodeItems);
        allPickCodeList.value = pickCodeItems;
        updateRefreshTime();
      } else {
        console.error('获取订单列表失败:', respOrder.msg);
        allPickCodeList.value = [];
      }
    } catch (error) {
      console.error('获取取餐码列表失败:', error);
      allPickCodeList.value = [];
    }
  };

  // 启动自动刷新
  const startAutoRefresh = () => {
    // 每5秒刷新一次
    autoRefreshTimer = setInterval(() => {
      if (currentShopId.value) {
        fetchPickCodeList();
      }
    }, 10000);
  };

  // 停止自动刷新
  const stopAutoRefresh = () => {
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
      autoRefreshTimer = null;
    }
  };

  // 初始化
  onMounted(async () => {
    initAudioPlayers();
    await loadShopList();
    const cachedShopId = readSelectedShop();
    if (cachedShopId) {
      currentShopId.value = cachedShopId;
      await fetchPickCodeList();
      // 启动自动刷新
      startAutoRefresh();
    }
  });

  // 清理
  onUnmounted(async () => {
    stopAutoRefresh();
    await stopScanner();
    okAudio?.pause();
    errorAudio?.pause();
  });

  const showResultToast = (text: string) => {
    successMessage.value = text;
    scanVerifyResult.value = text;
    setTimeout(() => {
      successMessage.value = '';
    }, 2000);
  };

  const initAudioPlayers = () => {
    if (!okAudio) {
      okAudio = new Audio(okSoundSrc);
      okAudio.preload = 'auto';
      okAudio.playsInline = true;
      okAudio.volume = 1;
      okAudio.load();
    }
    if (!errorAudio) {
      errorAudio = new Audio(errorSoundSrc);
      errorAudio.preload = 'auto';
      errorAudio.playsInline = true;
      errorAudio.volume = 1;
      errorAudio.load();
    }
  };

  const playSound = (audio: HTMLAudioElement | null, src: string) => {
    const target = audio ?? new Audio(src);
    target.playsInline = true;
    target.volume = 1;
    try {
      target.currentTime = 0;
      const playPromise = target.play();
      if (playPromise) {
        void playPromise.catch(() => {
          // 某些浏览器在高频播放时会拒绝，降级为克隆实例播放
          const clone = target.cloneNode(true) as HTMLAudioElement;
          clone.playsInline = true;
          clone.volume = 1;
          void clone.play().catch(() => {
            // ignore play errors
          });
        });
      }
    } catch (error) {
      // ignore play errors
    }
  };

  // 移动端（尤其 iOS）需要在用户手势中预先解锁音频播放
  const unlockAudio = () => {
    initAudioPlayers();
    try {
      [okAudio, errorAudio].forEach((audio) => {
        if (!audio) return;
        audio.muted = true;
        void audio.play().then(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.muted = false;
        });
      });
    } catch (error) {
      // ignore unlock errors
    }
  };

  const playSuccessSound = () => {
    playSound(okAudio, okSoundSrc);
  };

  const playErrorSound = () => {
    playSound(errorAudio, errorSoundSrc);
  };

  // 从扫码结果中提取取餐码，优先读取 URL 参数中的 pickCode
  const normalizePickCode = (rawText: string): string => {
    const text = rawText.trim();
    if (!text) return '';
    try {
      const parsedUrl = new URL(text);
      const pickCodeFromQuery =
        parsedUrl.searchParams.get('pickCode') ||
        parsedUrl.searchParams.get('pickcode') ||
        parsedUrl.searchParams.get('pickupCode');
      if (pickCodeFromQuery?.trim()) {
        return decodeURIComponent(pickCodeFromQuery.trim());
      }
      return text;
    } catch {
      return text;
    }
  };

  const verifyByCode = async (code: string, orderIdFromItem?: number) => {
    let orderId = orderIdFromItem;
    if (!orderId) {
      const targetItem = allPickCodeList.value.find((item) => item.pickCode === code);
      orderId = targetItem?.order?.orderId;
    }

    if (!orderId) {
      showResultToast(`取餐码 ${code} 不存在`);
      message.warning(`取餐码 ${code} 不存在`);
      playErrorSound();
      return;
    }

    try {
      const resp = await completeOrder({ orderId: orderId });
      if (resp.code === 200) {
        allPickCodeList.value = allPickCodeList.value.filter((item) => item.pickCode !== code);
        showResultToast(`取餐码 ${code} 核销成功`);
        message.success(`取餐码 ${code} 核销成功`);
        playSuccessSound();
      } else {
        showResultToast(`核销失败：${resp.msg || '接口返回错误'}`);
        message.error(resp.msg || '核销失败');
        playErrorSound();
      }
    } catch (e) {
      console.error('核销异常:', e);
      showResultToast(`核销异常：${e instanceof Error ? e.message : '未知错误'}`);
      message.error('核销异常，请稍后重试');
      playErrorSound();
    }
  };

  const processScanQueue = async () => {
    if (isQueueProcessing.value) return;
    isQueueProcessing.value = true;
    try {
      while (scanQueue.value.length > 0) {
        const code = scanQueue.value.shift();
        if (!code) continue;
        await verifyByCode(code);
      }
    } finally {
      isQueueProcessing.value = false;
    }
  };

  const pushScanToQueue = (code: string) => {
    const now = Date.now();
    const previous = lastScanTimeMap.get(code) || 0;
    if (now - previous < 3000) return;
    lastScanTimeMap.set(code, now);
    scanQueue.value.push(code);
    void processScanQueue();
  };

  const handleScanSuccess = (decodedText: string) => {
    const code = normalizePickCode(decodedText);
    if (!code) return;
    lastScannedText.value = code;
    scanVerifyResult.value = `已识别 ${code}，正在核销...`;
    pushScanToQueue(code);
  };

  const isHttpsOrLocal = (): boolean => {
    const { protocol, hostname } = window.location;
    return protocol === 'https:' || hostname === 'localhost' || hostname === '127.0.0.1';
  };

  const startScanner = async (): Promise<boolean> => {
    if (isScannerRunning.value) return true;
    if (!isHttpsOrLocal()) {
      message.warning('扫码需要 HTTPS 环境（localhost 除外）');
      return false;
    }

    try {
      const cameras = await Html5Qrcode.getCameras();
      if (!cameras.length) {
        message.warning('未检测到可用摄像头');
        return false;
      }
      if (!html5Qrcode) {
        html5Qrcode = new Html5Qrcode(scannerContainerId);
      }

      const isMobile = window.innerWidth <= 768;
      const qrboxSize = isMobile ? 180 : 220;
      const startConfig = {
        fps: 12,
        qrbox: { width: qrboxSize, height: qrboxSize },
      };

      const startErrorCallback = () => {
        // 忽略单次识别失败，避免频繁提示影响扫码体验
      };

      try {
        await html5Qrcode.start(
          { facingMode: { exact: 'environment' } },
          startConfig,
          handleScanSuccess,
          startErrorCallback,
        );
      } catch {
        try {
          await html5Qrcode.start(
            { facingMode: 'environment' },
            startConfig,
            handleScanSuccess,
            startErrorCallback,
          );
        } catch {
          const backCamera =
            cameras.find((item) => /back|rear|environment|后置|后摄/gi.test(item.label)) ||
            cameras[cameras.length - 1] ||
            cameras[0];
          await html5Qrcode.start(
            backCamera.id,
            startConfig,
            handleScanSuccess,
            startErrorCallback,
          );
        }
      }

      isScannerRunning.value = true;
      return true;
    } catch (error) {
      console.error('启动扫码失败:', error);
      message.error('启动扫码失败，请检查摄像头权限');
      await stopScanner();
      return false;
    }
  };

  const stopScanner = async () => {
    scanQueue.value = [];
    lastScanTimeMap.clear();
    if (!html5Qrcode) {
      isScannerRunning.value = false;
      return;
    }
    try {
      if (html5Qrcode.isScanning) {
        await html5Qrcode.stop();
      }
      await html5Qrcode.clear();
    } catch (error) {
      console.error('关闭扫码失败:', error);
    } finally {
      isScannerRunning.value = false;
      html5Qrcode = null;
    }
  };

  const openScanModal = async () => {
    unlockAudio();
    showScanModal.value = true;
    scanVerifyResult.value = '扫码后将自动核销';
    await nextTick();
    await startScanner();
  };

  const closeScanModal = async () => {
    await stopScanner();
    showScanModal.value = false;
  };

  // 通过输入框触发核销
  const handleVerifyInput = async () => {
    unlockAudio();
    const code = inputPickCode.value.trim();
    if (!code) {
      return;
    }
    await verifyByCode(code);
    inputPickCode.value = '';
  };

  // 点击取餐码触发核销（此时已拿到完整订单信息）
  const handleVerifyClick = async (item: PickCodeItem) => {
    unlockAudio();
    const code = item.pickCode;
    const orderId = item.order?.orderId;
    if (!orderId) {
      showResultToast(`取餐码 ${code} 缺少订单ID`);
      return;
    }
    await verifyByCode(code, orderId);
  };

  // 选中 AutoComplete 选项（键盘上下 + 回车/鼠标），只填入，不自动核销，避免误操作
  const handleAutoSelect = (code: string) => {
    inputPickCode.value = code;
    // 保持/恢复焦点在输入框上，方便继续按回车进行核销
    setTimeout(() => {
      autoCompleteRef.value?.focus?.();
    }, 0);
  };

  const handleClearInput = () => {
    inputPickCode.value = '';
    autoCompleteRef.value?.focus?.();
  };

  // 格式化日期时间
  const formatDateTime = (dateTime: string | Date | undefined): string => {
    if (!dateTime) return '-';
    try {
      const date = typeof dateTime === 'string' ? new Date(dateTime) : dateTime;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    } catch (e) {
      return '-';
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "top-decoration" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"title-wrapper\" data-v-26a5fe98><div class=\"title-icon\" data-v-26a5fe98><i class=\"fas fa-qrcode\" data-v-26a5fe98></i></div><div class=\"title-text\" data-v-26a5fe98><h1 class=\"title-main\" data-v-26a5fe98>取餐码核销</h1><p class=\"title-sub\" data-v-26a5fe98>Verification</p></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_auto_complete, {
                ref_key: "autoCompleteRef",
                ref: autoCompleteRef,
                value: inputPickCode.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((inputPickCode).value = $event)),
                class: "pickcode-auto-complete",
                options: autoCompleteOptions.value,
                placeholder: "输入取餐码回车后核销",
                onSelect: handleAutoSelect,
                onKeyup: _withKeys(handleVerifyInput, ["enter"])
              }, null, 8, ["value", "options"]),
              (inputPickCode.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "clear-btn",
                    type: "button",
                    onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                    onClick: handleClearInput
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                  ]), 32))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("button", {
            class: "verify-btn",
            onClick: handleVerifyInput
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fas fa-check-circle mr-2" }, null, -1),
            _createTextVNode("核销 ", -1)
          ])),
          _createElementVNode("button", {
            class: "scan-open-btn",
            onClick: openScanModal
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-qrcode mr-2" }, null, -1),
            _createTextVNode("二维码核销 ", -1)
          ]))
        ])
      ]),
      (successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-check-circle mr-2" }, null, -1)),
            _createTextVNode(_toDisplayString(successMessage.value), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "待核销取餐码", -1)),
            _createElementVNode("span", _hoisted_11, _toDisplayString(allPickCodeList.value.length), 1)
          ]),
          (lastRefreshTime.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-sync-alt mr-1" }, null, -1)),
                _createTextVNode(" 最近更新：" + _toDisplayString(lastRefreshTime.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allPickCodeList.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_popover, {
                  key: item.pickCode,
                  placement: "top",
                  trigger: "hover"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "popover-label" }, "订单号：", -1)),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(item.order?.orderNo || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "popover-label" }, "取餐码：", -1)),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.pickCode), 1)
                      ]),
                      (item.order?.shopName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "popover-label" }, "餐厅：", -1)),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(item.order.shopName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.order?.customerName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "popover-label" }, "客户：", -1)),
                            _createElementVNode("span", _hoisted_24, _toDisplayString(item.order.customerName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.order?.totalAmount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "popover-label" }, "金额：", -1)),
                            _createElementVNode("span", _hoisted_26, "¥" + _toDisplayString(item.order.totalAmount.toFixed(2)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.order?.createTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "popover-label" }, "下单时间：", -1)),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(formatDateTime(item.order.createTime)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.order?.foodList && item.order.foodList.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "popover-divider" }, null, -1)),
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "popover-section-title" }, "菜品明细", -1)),
                            _createElementVNode("div", _hoisted_30, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.order.foodList, (food, foodIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: foodIndex,
                                  class: "popover-food-item"
                                }, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(food.shopFoodName || food.foodName || '-'), 1),
                                    _createElementVNode("span", _hoisted_33, "x" + _toDisplayString(food.quantity || 1), 1)
                                  ]),
                                  (food.foodSpecName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, " 规格：" + _toDisplayString(food.foodSpecName), 1))
                                    : _createCommentVNode("", true),
                                  (food.foodCookDesc)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 做法：" + _toDisplayString(food.foodCookDesc), 1))
                                    : _createCommentVNode("", true),
                                  (food.remark)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, " 备注：" + _toDisplayString(food.remark), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("span", _hoisted_38, "¥" + _toDisplayString((food.amount || food.price || 0).toFixed(2)), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["code-item", { 'vip-code': isVipCode(item.pickCode) }]),
                      onClick: ($event: any) => (handleVerifyClick(item))
                    }, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "code-glow" }, null, -1)),
                      _createElementVNode("div", _hoisted_40, [
                        (isVipCode(item.pickCode))
                          ? (_openBlock(), _createElementBlock("i", _hoisted_41))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(item.pickCode), 1)
                      ])
                    ], 10, _hoisted_39)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          (allPickCodeList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "fas fa-inbox empty-icon" }, null, -1),
                _createElementVNode("p", { class: "empty-text" }, "暂无待核销的取餐码", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (showScanModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", { class: "scan-modal-header" }, [
              _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "scan-modal-title" }, "二维码核销", -1)),
              _createElementVNode("button", {
                class: "scan-close-btn",
                type: "button",
                onClick: closeScanModal
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("span", null, "状态：" + _toDisplayString(isScannerRunning.value ? '扫描中' : '摄像头未启动'), 1),
              _createElementVNode("span", null, "待处理：" + _toDisplayString(scanQueue.value.length), 1)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("p", _hoisted_48, " 最近识别：" + _toDisplayString(lastScannedText.value || '暂无'), 1),
              _createElementVNode("p", _hoisted_49, " 核销结果：" + _toDisplayString(scanVerifyResult.value || '等待扫码'), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", {
                id: scannerContainerId,
                class: "scan-view"
              }),
              (!isScannerRunning.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, _cache[21] || (_cache[21] = [
                    _createElementVNode("span", null, "无法启动摄像头，请检查 HTTPS、摄像头权限或设备可用性", -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "bottom-decoration" }, null, -1))
  ]))
}
}

})